export function createTokenLink(link) {
  const accessToken = window.localStorage.getItem('accessToken');
  return `${link}?token=${accessToken}`;
}
